import getOr from "lodash/fp/getOr";
import { GLOBAL_CONSTANTS } from "../../global/constants";
import { products } from "../../utils/api";
import { showLimit } from "./searchBar";
// import { LocalStorage } from "../../models/LocalStorage";
import { Classification } from "../../models/classification";
import { changeQueryString, getParamUrl } from "../../utils/url";
import { triggerSelectionAndClick } from "../../utils/utils";

const $ = window.jQuery;

export function setUpClassifications() {
  $('body').on('click', '.section-goods .item-tree[selectable=true] > .label-box', function (e) {
    try {
      if (window.getSelection().getRangeAt(0).startOffset === window.getSelection().getRangeAt(0).endOffset) {
        const item = $(this).parent();
        const code = item.attr('code');
        const parent = item.parent().parent();
        const isopen = item.attr('isopen');

        if (e.altKey && parent.attr("type") === "section") {
          goodsShowAll([code]);
          return;
        }

        if (item.find('.sub .item-tree').length) {
          if ((isNaN(code) || code * 1 > 0) && !item.hasClass("active") && !item.hasClass("has-pull")) {
            goodsClick(code, () => {
              item.removeClass("has-pull").addClass("has-pull");

              if (isopen) {
                let subItem = item.find(".sub .item-tree.parent > .label-box") || [];
                if (!subItem.length) {
                  subItem = item.find(".sub .item-tree.current > .label-box") || [];
                }
                if (subItem.length) {
                  subItem.parent().attr('isopen', true);
                  triggerSelectionAndClick(subItem[0]);
                }
              }
            });
          }
          item.toggleClass('active');
        } else {
          if ((isNaN(code) || code * 1 > 0) && !item.hasClass("active") && !item.hasClass("has-pull")) {
            goodsClick(code, () => {
              item.removeClass("has-pull").addClass("has-pull");
              item.toggleClass('active');

              if (isopen) {
                let subItem = item.find(".sub .item-tree.parent > .label-box") || [];
                if (!subItem.length) {
                  subItem = item.find(".sub .item-tree.current > .label-box") || [];
                }
                if (subItem.length) {
                  subItem.parent().attr('isopen', true);
                  triggerSelectionAndClick(subItem[0]);
                }
              }
            });
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  });
}

function goodsClick(hsCode, success) {
  const apiTime = Date.now();
  window.apiTime = apiTime;
  products(window.searchData.destination, [hsCode], undefined, function (result) {
    if (result.length) {
      for (let i = 0; i < result.length; i++) {
        const item = result[i];
        item.render($('.section-goods .tree-box'));
      }
      typeof success === "function" && success();
    }
  }, function (error) {
    const errorCode = getOr('', 'error_code')(error);
    if (errorCode === GLOBAL_CONSTANTS.ERROR_CODE.LIMIT) {
      showLimit();
      return;
    }
  }, apiTime);
}

export function loadClassification(data, isShowFullTree) {
  window.currentData = data;
  // const main = data[0];
  $('.section-result .main-box .border-box').html("");
  data.forEach(element => {
    element.render($('.section-result .main-box .border-box'));
  });

  // main.render($('.section-result .main-box .border-box'), main);
  for (let i = 1; i < data.length; i++) {
    const item = data[i];
    const element = $(`<div class="item"></div>`);
    $('.section-result .other-relevant-results .tree-box').html(element);
    item.render(element, item);
  }
  $('.section-result .other-relevant-results .tree-box .item:first-child .item-tree').each(function (i, obj) {
    if ($(obj).find('.sub .item-tree').length) {
      $(obj).removeClass('active').addClass('active');
    }
  });

  // if (LocalStorage.isLoggedIn()) {
  loadGoodsChapter(isShowFullTree);
  // }

  $('.section-result .main-box .border-box .item-tree').each(function (i, obj) {
    if ($(obj).find('.sub .item-tree').length) {
      $(obj).removeClass('active').addClass('active');
    }
  });
  $('body').off('click', '.item-tree[selectable="false"][is_group="false"]');
  $('body').on('click', '.item-tree[selectable="false"][is_group="false"]', function () {
    let hsCodeParam = getParamUrl("hs");
    let hsCode = $(this).closest(".item-tree").attr("data-id");
    if (hsCode && hsCode !== hsCodeParam) {
      let url = changeQueryString("hs", hsCode);
      url = changeQueryString("product", undefined, url);
      window.location.href = url;
    }
  });

  $('body').off('click', '.section-result .main-box .item-tree[selectable=true] > .label-box');
  $('body').on('click', '.section-result .main-box .item-tree[selectable=true] > .label-box', function () {
    try {
      if (window.getSelection().getRangeAt(0).startOffset === window.getSelection().getRangeAt(0).endOffset) {
        const item = $(this).parent();
        if (item.find('.sub .item-tree').length) {
          item.toggleClass('active');
        }
      }
    } catch (error) {
      console.error(error);
    }
  });

  $('.section-result .other-relevant-results').hide();
  if (data.length > 1) {
    $('.section-result .satisfied-box').show();
  } else {
    $('.section-result .satisfied-box').hide();
  }
  $('.section-result').css('display', "block");
}


function loadGoodsChapter(isShowFullTree) {
  $('.section-goods .tree-box').html("");
  Classification.renderGoods($('.section-goods .tree-box'));
  products(window.searchData.destination, undefined, ['2'], function (result) {
    if (result.length) {
      for (let i = 0; i < result.length; i++) {
        const item = result[i];
        item.render($('.section-goods .tree-box'));
      }

      $(".section-goods .tree-box > .item-tree:not(.parent)").css('display', isShowFullTree ? 'none' : "block");
      if (isShowFullTree) {
        let parentItem = $(".section-goods .tree-box > .item-tree.parent").addClass("active");
        let subItem = parentItem.find(".sub .item-tree.parent > .label-box");
        if (!subItem.length) {
          subItem = parentItem.find(".sub .item-tree.current > .label-box");
        }

        if (subItem.length) {
          subItem.parent().attr('isopen', true);
          triggerSelectionAndClick(subItem[0]);
        }
      }
    }
    // goodsShowClassify();
  }, function (error) {
    const errorCode = getOr('', 'error_code')(error);
    if (errorCode === GLOBAL_CONSTANTS.ERROR_CODE.LIMIT) {
      showLimit();
      return;
    }
    // goodsShowClassify();
  });
}

function goodsShowAll(parent = ["01"]) {
  products(window.searchData.destination, parent, undefined, function (result) {
    if (result.length) {
      for (let i = 0; i < result.length; i++) {
        const item = result[i];
        item.render($('.section-goods .tree-box'));
        goodsShowAll([item.code], undefined);
      }
    }
    $(`.item-tree[code='${parent[0]}'][selectable='true']`).removeClass("active").addClass("active");
  }, function (error) {
    const errorCode = getOr('', 'error_code')(error);
    if (errorCode === GLOBAL_CONSTANTS.ERROR_CODE.LIMIT) {
      showLimit();
      return;
    }
  });
}